import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import ThermostatDetailsHeader from "nx-components/Thermostat/ThermostatDetailsHeader";
import DetailsHeaderWrapper from "nexia_mobile/components/Details/DetailsHeaders/DetailsHeaderWrapper";
import Sensor from "nexia_mobile/models/mixins/device_features/sensor";
import DrawUpdates from "nexia_mobile/components/DrawUpdates";
import prefixStyles from "nx-components/utils/prefixStyles";

const style = prefixStyles({
  padding: "",
  background: "none",
  minHeight: "20vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export default class ThermostatHeader extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
  };

  render() {
    const { model } = this.props;

    let temperatureOutside = null;
    let humidityRelative = null;

    if (model.hasFeature(Sensor)) {
      temperatureOutside = parseFloat(
        model.getSensorValue(Sensor.Type.OUTDOOR_TEMPERATURE)
      );

      const humidity = model.getSensorValue(Sensor.Type.RELATIVE_HUMIDITY);
      humidityRelative = parseFloat(humidity) / 100;
    }

    const compressorSpeed =
      model.get("compressor_speed") == null
        ? null
        : model.get("compressor_speed");

    return (
      <React.Fragment>
        <DrawUpdates
          listenTo={model}
          events={["change"]}
          getNodeToStyle={() => this._wrapper}
        />
        <DetailsHeaderWrapper
          style={style}
          innerRef={(el) => (this._wrapper = el)}
        >
          <ThermostatDetailsHeader
            humidityRelative={humidityRelative}
            systemStatus={model.get("status")}
            temperature={model.get("temperature")}
            temperatureOutside={temperatureOutside}
            compressorSpeed={compressorSpeed}
          />
        </DetailsHeaderWrapper>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Details/DetailsHeaders/ThermostatHeader.jsx